import request from 'manager/utils/request';
import { REST_SERVICE } from 'manager/config';

const approve = {
  //查询未审核列表
  query(params) {
    return request({
      url: REST_SERVICE.approve.query,
      method: 'get',
      params
    });
  },
  //显示企业用户详情
  showDetail(params) {
    return request({
      url: REST_SERVICE.approve.showDetail,
      method: 'get',
      params
    });
  },
  //审核
  approveUser(params) {
    return request({
      url: REST_SERVICE.approve.approveUser,
      method: 'post',
      data: params
    });
  },

  // 上门预约审核待审核
  doorapprove(params) {
    return request({
      url: REST_SERVICE.approve.doorapprove,
      method: 'get',
      params
    });
  },

  // 预约排号审核未受理
  appointmentnumber(params) {
    return request({
      url: REST_SERVICE.approve.appointmentnumber,
      method: 'get',
      params
    });
  },

  // 导出功能
  exportModel(params) {
    window.open(
      REST_SERVICE.approve.exportAppointmentInfo +
        '?status=' +
        params.status +
        '&yyyhmc=' +
        params.yyyhmc +
        '&beginTime=' +
        params.beginTime +
        '&endTime=' +
        params.endTime +
        '&yybh=' +
        params.yybh +
        '&yysx=' +
        params.yysx +
        '&yyjg=' +
        params.yyjg +
        '&zjh=' +
        params.zjh
    );
    // return request({
    //   url: REST_SERVICE.approve.exportAppointmentInfo,
    //   method: 'get',
    //   params
    // }).then((res) => {
    //   if (res && res.success !== false) {
    //     console.log('llll',params)
    //     window.open(REST_SERVICE.approve.exportAppointmentInfo + '?status=' + params.status + '?yyyhmc=' + params.yyyhmc + '?beginTime=' + params.beginTime + '?endTime=' + params.endTime+ '?yybh='+ params.yybh+ '?yysx='+ params.yysx+ '?yyjg='+ params.yyjg+ '?zjh='+ params.zjh);
    //   }
    //   return res;
    // })
  },

  findFileById(params) {
    return request({
      url: REST_SERVICE.approve.findFileById,
      method: 'get',
      params
    });
  },
  //上门预约审核-获取详情
  detailsById(params) {
    return request({
      url: REST_SERVICE.approve.detailsById,
      method: 'get',
      params
    });
  },

  getAppointmentInfoByCode(params) {
    return request({
      url: REST_SERVICE.approve.getAppointmentInfoByCode,
      method: 'get',
      params
    });
  },
  // 上门预约审核-待审核-预审
  lookThrough(data) {
    return request({
      url: REST_SERVICE.approve.lookThrough,
      method: 'post',
      data
    });
  },
  //上门预约审核-通过-履约
  doorfinish(params) {
    return request({
      url: REST_SERVICE.approve.doorfinish,
      method: 'post',
      data: params
    });
  },
  //上门预约审核-通过-打印
  doorPrintDTD(params) {
    return request({
      url: REST_SERVICE.approve.doorPrintDTD,
      method: 'post',
      data: params
    });
  },
  setFileIds(data) {
    //企业用户保存证明材料
    return request({
      url: REST_SERVICE.approve.setFileIds,
      method: 'post',
      data
    });
  },
  /**
   * @description 获取地址数据根据id
   */
  getByCode(params) {
    return request({
      url: REST_SERVICE.express.findByOfficeCode,
      method: 'get',
      params
    });
  },
  //获取文件的类型
  getUrlAndType: function(file) {
    let dataFormat = file.fileName.split('.');
    if (
      dataFormat[dataFormat.length - 1].toLowerCase() === 'jpg' ||
      dataFormat[dataFormat.length - 1].toLowerCase() === 'jpeg' ||
      dataFormat[dataFormat.length - 1].toLowerCase() === 'png'
    ) {
      file.dataFormat = 'img';
    }
  },
  getSystemTime(params) {
    // 获取系统时间
    return request({
      url: REST_SERVICE.approve.getSystemTime,
      method: 'get',
      params
    });
  },
  changeStatus(params) {
    // 修改受理状态
    return request({
      url: REST_SERVICE.approve.changeStatus,
      method: 'post',
      data: params
    });
  }
};
export default approve;
